package meineglasfaser.frontend.common.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.height
import com.varabyte.kobweb.compose.css.width
import org.jetbrains.compose.web.dom.Img

enum class PromLogoType(val fileName: String) {
    BLOCK("logo-block.jpg"),
    LANG("logo-lang.jpg"),
    MAIN("logo-main.jpg"),
    MAIN_COMPACT("logo-main-compact.jpg"),
    SSI("logo-ssi.png");
}

@Composable
fun PromLogo(type: PromLogoType) {
    Img(
        src = "/assets/images/${type.fileName}",
        alt = "Prometheus Network Logo",
        attrs = {
            if (type == PromLogoType.SSI) {
                width(400)
            }
        }
    )
}
